import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-triangle\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,6.57,19.73,18H4.27L12,6.57m0-2.79a1,1,0,0,0-.83.44L1.56,18.44A1,1,0,0,0,2.38,20H21.62a1,1,0,0,0,.82-1.56L12.83,4.22A1,1,0,0,0,12,3.78Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol